import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import { Plus } from "@phosphor-icons/react";
import { toast } from "sonner";

export function ProductCard({ product, index = 0 }) {
  const { add } = useCart();

  const handleAdd = () => {
    add(product);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <div
      className="group flex flex-col border border-[#D2D5CD] bg-white transition-colors duration-200 hover:border-[#2E523A]/40 animate-fade-up rounded-xl overflow-hidden"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`product-card-${product.lookup_key}`}
    >
      <div className="relative aspect-square overflow-hidden bg-[#EAEBE6]">
        <img
          src={product.image}
          alt={product.name}
          className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 text-[10px] tracking-[0.15em] uppercase font-bold bg-white/85 backdrop-blur px-2.5 py-1 rounded-full text-[#1A1C19]">
          {product.category}
        </span>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-display text-lg font-bold text-[#1A1C19] leading-tight">{product.name}</h3>
        <p className="text-sm text-[#63675E] mt-1 line-clamp-2 flex-1">{product.description}</p>
        <div className="flex items-center justify-between mt-4">
          <span className="font-display text-2xl font-bold text-[#2E523A]">${product.price}</span>
          <Button
            onClick={handleAdd}
            className="rounded-full bg-[#1A1C19] hover:bg-[#2E523A] text-white h-10 px-4 transition-colors duration-200"
            data-testid={`add-to-cart-${product.lookup_key}`}
          >
            <Plus size={18} weight="bold" /> Add
          </Button>
        </div>
      </div>
    </div>
  );
}
